// @ts-nocheck

import { JsonRpcApiMethodNames } from '../constants/api';
import type { MyMatchState } from '../states/mymatch';
import { MyMatchActionTypes } from '../types/actions/mymatch';
import { NetworkActionTypes } from '../types/actions/network';

const initialFutureEntities = {
  bets: {},
  outcomes: {},
};

export const mymatchInitialState: MyMatchState = {
  getFutureOddsIsLoadingMatchIds: [],
  myMatchModeMatchIds: [],
  futureEntities: initialFutureEntities,
};

const handledActionTypes = [
  MyMatchActionTypes.SET_MY_MATCH_MODE,
  MyMatchActionTypes.UNSET_MY_MATCH_MODE,
  NetworkActionTypes.SEND,
  MyMatchActionTypes.RECEIVED_GET_FUTURE_ODDS_ENTITIES,
  MyMatchActionTypes.RECEIVED_GET_FUTURE_ODDS_ENTITIES_UPDATES,
  MyMatchActionTypes.CLEAR_MY_MATCH_MODE_MATCH_IDS,
];

const myMatchReducer = (state: MyMatchState = mymatchInitialState, action: unknown) => {
  if (~handledActionTypes.indexOf(action.type)) {
    if (action.type === MyMatchActionTypes.SET_MY_MATCH_MODE) {
      const { matchId } = action.payload;

      return {
        ...state,
        myMatchModeMatchIds: [...state.myMatchModeMatchIds, matchId],
      };
    }

    if (action.type === MyMatchActionTypes.UNSET_MY_MATCH_MODE) {
      const { matchId } = action.payload;

      return {
        ...state,
        myMatchModeMatchIds: state.myMatchModeMatchIds.filter((k) => `${k}` !== `${matchId}`),
        getFutureOddsIsLoadingMatchIds: state.getFutureOddsIsLoadingMatchIds.filter((k) => `${k}` !== `${matchId}`),
      };
    }

    if (
      action.type === NetworkActionTypes.SEND &&
      action?.payload?.myMatch?.method === JsonRpcApiMethodNames.GET_FUTURE_ODDS
    ) {
      const { triggerLoading } = action.meta ?? {};
      const { myMatch } = action.payload ?? {};
      const { params } = myMatch ?? {};
      const { matchId } = params ?? {};

      return triggerLoading && typeof matchId === 'number'
        ? {
            ...state,
            getFutureOddsIsLoadingMatchIds: [...state.getFutureOddsIsLoadingMatchIds, matchId],
          }
        : state;
    }

    if (action.type === MyMatchActionTypes.RECEIVED_GET_FUTURE_ODDS_ENTITIES) {
      const { bets, outcomes, matchId } = action.payload ?? {};

      return {
        ...state,
        getFutureOddsIsLoadingMatchIds: state.getFutureOddsIsLoadingMatchIds.filter((k) => `${k}` !== `${matchId}`),
        futureEntities: {
          bets,
          outcomes,
        },
      };
    }

    if (action.type === MyMatchActionTypes.RECEIVED_GET_FUTURE_ODDS_ENTITIES_UPDATES) {
      const { bets, outcomes } = action.payload ?? {};

      return {
        ...state,
        futureEntities: {
          bets,
          outcomes,
        },
      };
    }

    if (action.type === MyMatchActionTypes.CLEAR_MY_MATCH_MODE_MATCH_IDS) {
      if (state.myMatchModeMatchIds.length) {
        return {
          ...state,
          myMatchModeMatchIds: [],
        };
      }
    }
  }

  return state;
};

export default myMatchReducer;
